import { sanitize } from 'lib/sanitize';
import React from 'react';

export type IframeProps = {
    classnames?: string;
    iframeClassnames?: string;
    src?: string;
    title?: string;
};

const iframTemplate = ({ iframeClassnames, src, title }: IframeProps) => `
<iframe
    class="${iframeClassnames}"
    src="${src}"
    frameBorder="0"
    allow="autoplay; fullscreen; picture-in-picture"
    allowFullScreen="true"
    title="${sanitize(title || '')}"
    data-ready="true"
></iframe>
`;

function Iframe(props: IframeProps) {
    return (
        <div
            className={props.classnames}
            dangerouslySetInnerHTML={{
                __html: iframTemplate(props),
            }}
        />
    );
}

export { Iframe };
